module.exports = __webpack_public_path__ + "media/images/icons/left-arrow-6d4b3837ff3773845b35de7318b3e6f2.svg";